import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';

@Component({
  selector: 'existing-company-warning',
  imports: [MatIcon, MatButton, RouterLink, TranslocoPipe],
  providers: [provideTranslocoScope('sharedDialogs')],
  template: `
    <div class="alert-container">
      <div class="alert-content">
        <mat-icon class="alert-icon">warning</mat-icon>
        <div class="alert-text-container">
          <div class="alert-title">{{ 'sharedDialogs.existingCompanyWarning.title' | transloco }}</div>
          <div class="alert-description">
            <span>
              {{ 'sharedDialogs.existingCompanyWarning.descriptionBefore' | transloco }}
              <a class="alert-link" href="mailto:help@ideal.io">help&#64;ideal.io</a>
              {{ 'sharedDialogs.existingCompanyWarning.descriptionAfter' | transloco }}
            </span>
          </div>
        </div>

      </div>
      <button mat-flat-button class="alert-button" (click)="goToCompany()">
        <mat-icon>arrow_forward</mat-icon>
        {{ companyName() }}
      </button>
    </div>
  `,
  styleUrls: ['./existing-company-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExistingCompanyWarningComponent {
  companyName = input<string>('');
  companyLink = input<string>('');
  companyId = input<number>();
  linkClicked = output<boolean>();

  router = inject(Router);

  goToCompany() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`companies/company/${ this.companyId() }`]);
      this.linkClicked.emit(true);
    })
  }
}
